import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <center>
        <h3>&copy; 2022 <a href="https://www.copyright.gov.in/frmCEAC.aspx">Enforcement Advisory Council (CEAC).</a> All rights reserved.</h3>
      </center>
    </footer>
  );
}
